<template>
  <VersionSelect v-if="plp_task_id" fluid>
    <template #content="{ data, readonly, onChange, onBlur, onCreate }">
      <ExpAgency
        :value="data"
        @change="onChange"
        :readonly="readonly"
        :onCreate="onCreate"
        @blur="onBlur"
      />
    </template>
  </VersionSelect>
</template>

<script>
import VersionSelect from '@/components/VersionSelect'
import ExpAgency from '@/components/expAgency/ExpAgency'

import { mapGetters } from 'vuex'

export default {
  components: { VersionSelect, ExpAgency },
  data: () => ({}),
  computed: {
    ...mapGetters(['plp_task_id']),
  },
}
</script>
